<header class="site-header">
  <div class="utility-bar">
    <div class="utility-bar__inner">
      <div class="utility-lang" role="group" [attr.aria-label]="'header.language' | t">
        <button
          type="button"
          [class.utility-lang__option--active]="(language$ | async) === 'ar'"
          class="utility-lang__option"
          (click)="setLanguage('ar')"
        >
          العربية
        </button>
        <span class="utility-lang__sep" aria-hidden="true">|</span>
        <button
          type="button"
          [class.utility-lang__option--active]="(language$ | async) === 'en'"
          class="utility-lang__option"
          (click)="setLanguage('en')"
        >
          English
        </button>
      </div>
    </div>
  </div>

  <div class="main-bar">
    <div class="main-bar__inner">
      <a routerLink="/" class="brand-link" [attr.aria-label]="'header.home_aria' | t">
        <img
          class="brand-logo"
          src="/assets/brand/figma/nav-logo-sm.png"
          width="128"
          height="56"
          alt="ZeroTech Stores"
          decoding="async"
          fetchpriority="low"
        />
      </a>

      <div class="search-wrap" role="search">
        <div class="search-box" [class.search-box--open]="searchOpen">
          <button
            type="button"
            class="search-icon-btn"
            (click)="onSearch(searchInput.value)"
            [attr.aria-label]="'common.search' | t"
          >
            <img class="search-icon" src="/assets/icons/figma/search.svg" alt="" aria-hidden="true" width="24" height="24" />
          </button>
          <input
            #searchInput
            type="text"
            autocomplete="off"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-expanded]="searchOpen"
            aria-controls="headerSearchSuggestions"
            [placeholder]="'header.search_placeholder' | t"
            (input)="onSearchInput(searchInput.value)"
            (keydown)="onSearchKeydown($event)"
            (focus)="onSearchInput(searchInput.value)"
          />
          <button
            type="button"
            class="search-submit"
            (click)="onSearch(searchInput.value)"
            [attr.aria-label]="'common.search' | t"
          >
            <span class="search-submit__label">{{ 'common.search' | t }}</span>
          </button>
        </div>

        <div
          id="headerSearchSuggestions"
          class="search-suggestions"
          *ngIf="searchOpen"
          role="listbox"
          [attr.aria-label]="'header.search_suggestions' | t"
        >
          <div class="search-suggestions__status" *ngIf="searchLoading">{{ 'header.search_loading' | t }}</div>
          <button
            type="button"
            class="search-suggestions__item"
            *ngFor="let product of searchSuggestions; let i = index; trackBy: trackByProductId"
            role="option"
            [attr.aria-selected]="i === searchActiveIndex"
            [class.search-suggestions__item--active]="i === searchActiveIndex"
            (mousedown)="$event.preventDefault()"
            (click)="openSuggestion(product)"
          >
            <img
              class="search-suggestions__thumb"
              [appMediaSrc]="product.imageUrl || ''"
              appMediaPlaceholder="/assets/placeholder.svg"
              appMediaProfile="thumb"
              [alt]="product | productDisplayName"
              width="48"
              height="48"
              loading="lazy"
              decoding="async"
            />
            <span class="search-suggestions__meta">
              <span class="search-suggestions__name" dir="auto">{{ product | productDisplayName }}</span>
              <span class="search-suggestions__price">{{ product.discountPrice || product.price | currency: 'EGP' }}</span>
            </span>
          </button>
          <p class="search-suggestions__empty" *ngIf="!searchLoading && searchSuggestions.length === 0">
            {{ 'header.search_no_results' | t }}
          </p>
          <button
            type="button"
            class="search-suggestions__all"
            *ngIf="searchTerm"
            (mousedown)="$event.preventDefault()"
            (click)="viewAllSearchResults()"
          >
            {{ 'header.search_view_all' | t }} “{{ searchTerm }}”
          </button>
        </div>
      </div>

      <div class="main-actions main-actions--desktop">
        <a class="signin-btn" routerLink="/account/login" *ngIf="!(isLoggedIn$ | async)">
          {{ 'header.sign_in' | t }}
        </a>
        <button class="signin-btn" type="button" *ngIf="isLoggedIn$ | async" (click)="logout()">
          {{ 'header.logout' | t }}
        </button>
        <a class="icon-btn" routerLink="/compare" [attr.aria-label]="'header.compare' | t">
          <img class="icon-btn__img icon-btn__img--compare" src="/assets/icons/figma/compare.svg" alt="" aria-hidden="true" width="20" height="20" />
          <ng-container *ngIf="compareCount$ | async as cc">
            <span class="cart-badge" *ngIf="cc > 0">{{ formatBadgeCount(cc) }}</span>
          </ng-container>
        </a>
        <a class="icon-btn" routerLink="/wishlist" [attr.aria-label]="'header.wishlist' | t">
          <img class="icon-btn__img" src="/assets/icons/figma/wishlist.svg" alt="" aria-hidden="true" width="24" height="24" />
        </a>
        <a class="icon-btn cart-btn" routerLink="/cart" [attr.aria-label]="'header.cart' | t">
          <img class="icon-btn__img" src="/assets/icons/figma/cart.svg" alt="" aria-hidden="true" width="24" height="24" />
          <span class="cart-badge" *ngIf="cartCount$ | async as count">{{ formatBadgeCount(count) }}</span>
        </a>
        <ng-container *ngIf="isLoggedIn$ | async">
          <a class="icon-btn icon-btn--header-extra" routerLink="/account" [attr.aria-label]="'header.account' | t">
            <img class="icon-btn__img" src="/assets/icons/figma/user.svg" alt="" aria-hidden="true" width="24" height="24" />
          </a>
          <a
            class="icon-btn icon-btn--header-extra"
            routerLink="/account"
            [queryParams]="{ tab: 'orders' }"
            [attr.aria-label]="'header.my_orders' | t"
          >
            <img class="icon-btn__img" src="/assets/icons/figma/orders.svg" alt="" aria-hidden="true" width="24" height="24" />
          </a>
        </ng-container>
      </div>

      <div class="main-bar__trailing">
        <div class="main-actions main-actions--mobile">
          <a class="icon-btn cart-btn" routerLink="/cart" [attr.aria-label]="'header.cart' | t">
            <img class="icon-btn__img" src="/assets/icons/figma/cart.svg" alt="" aria-hidden="true" width="24" height="24" />
            <span class="cart-badge" *ngIf="cartCount$ | async as count">{{ formatBadgeCount(count) }}</span>
          </a>
          <a class="icon-btn" routerLink="/wishlist" [attr.aria-label]="'header.wishlist' | t">
            <img class="icon-btn__img" src="/assets/icons/figma/wishlist.svg" alt="" aria-hidden="true" width="24" height="24" />
          </a>
          <ng-container *ngIf="isLoggedIn$ | async">
            <a class="icon-btn" routerLink="/account" [attr.aria-label]="'header.account' | t">
              <img class="icon-btn__img" src="/assets/icons/figma/user.svg" alt="" aria-hidden="true" width="24" height="24" />
            </a>
            <a
              class="icon-btn"
              routerLink="/account"
              [queryParams]="{ tab: 'orders' }"
              [attr.aria-label]="'header.my_orders' | t"
            >
              <img class="icon-btn__img" src="/assets/icons/figma/orders.svg" alt="" aria-hidden="true" width="24" height="24" />
            </a>
          </ng-container>
        </div>
        <button
          id="mobileMenuButton"
          class="mobile-menu-toggle"
          type="button"
          [attr.aria-label]="'header.shop_by_category' | t"
          aria-controls="mobileNavDrawer"
          [attr.aria-expanded]="mobileMenuOpen"
          (click)="toggleMobileMenu()"
        >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>
      </div>
    </div>
  </div>

  <div class="mobile-drawer-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu(true)" aria-hidden="true"></div>
  <aside
    id="mobileNavDrawer"
    class="mobile-nav-drawer"
    [class.mobile-nav-drawer--open]="mobileMenuOpen"
    [attr.aria-hidden]="!mobileMenuOpen"
    [attr.aria-label]="'header.shop_by_category' | t"
  >
    <div class="mobile-nav-drawer__head">
      <button type="button" class="mobile-nav-drawer__close" (click)="closeMobileMenu(true)" [attr.aria-label]="'Close menu'">
        <span aria-hidden="true">×</span>
      </button>
      <img class="mobile-nav-drawer__brand" src="/assets/brand/figma/nav-logo-sm.png" alt="ZeroTech Stores" width="86" height="32" decoding="async" />
    </div>

    <div class="mobile-nav-drawer__body">
      <p class="mobile-nav-section-label">{{ 'header.categories_label' | t }}</p>

      <nav class="mobile-nav-categories" *ngIf="categoriesSplit$ | async as split">
        <div class="mobile-nav-cat-group" *ngFor="let category of split.topLevel; trackBy: trackByCategoryId">
          <div class="mobile-nav-cat" [class.mobile-nav-cat--expanded]="isMobileCategoryExpanded(category.id)">
            <button
              type="button"
              class="mobile-nav-cat__toggle"
              *ngIf="hasChildren(category); else leafChevron"
              (click)="toggleMobileCategory(category.id, $event)"
              [attr.aria-expanded]="isMobileCategoryExpanded(category.id)"
              [attr.aria-label]="
                (isMobileCategoryExpanded(category.id) ? 'header.collapse_category' : 'header.expand_category') | t
              "
            >
              <span class="mobile-nav-cat__chevron" aria-hidden="true"></span>
            </button>
            <ng-template #leafChevron>
              <span class="mobile-nav-cat__toggle mobile-nav-cat__toggle--static" aria-hidden="true">
                <span class="mobile-nav-cat__chevron mobile-nav-cat__chevron--static"></span>
              </span>
            </ng-template>

            <a
              class="mobile-nav-cat__name"
              [routerLink]="['/category', category.id]"
              (click)="closeMobileMenu()"
            >
              {{ category | categoryName }}
            </a>

            <span class="mobile-nav-cat__count" *ngIf="categoryCount(category) as count">{{ count }}</span>
          </div>

          <div class="mobile-nav-cat__children" *ngIf="hasChildren(category) && isMobileCategoryExpanded(category.id)">
            <ng-container *ngFor="let child of getChildren(category); trackBy: trackByCategoryId">
              <div class="mobile-nav-cat-group mobile-nav-cat-group--nested" *ngIf="hasChildren(child); else mobileLeafChild">
                <div class="mobile-nav-cat mobile-nav-cat--nested" [class.mobile-nav-cat--expanded]="isMobileCategoryExpanded(child.id)">
                  <button
                    type="button"
                    class="mobile-nav-cat__toggle"
                    (click)="toggleMobileCategory(child.id, $event)"
                    [attr.aria-expanded]="isMobileCategoryExpanded(child.id)"
                    [attr.aria-label]="
                      (isMobileCategoryExpanded(child.id) ? 'header.collapse_category' : 'header.expand_category') | t
                    "
                  >
                    <span class="mobile-nav-cat__chevron" aria-hidden="true"></span>
                  </button>
                  <a
                    class="mobile-nav-cat__name"
                    [routerLink]="['/category', child.id]"
                    (click)="closeMobileMenu()"
                  >
                    {{ child | categoryName }}
                  </a>
                  <span class="mobile-nav-cat__count" *ngIf="categoryCount(child) as childCount">{{ childCount }}</span>
                </div>

                <div class="mobile-nav-cat__children mobile-nav-cat__children--deep" *ngIf="isMobileCategoryExpanded(child.id)">
                  <ng-container *ngFor="let grand of getChildren(child); trackBy: trackByCategoryId">
                    <div class="mobile-nav-cat-group mobile-nav-cat-group--nested" *ngIf="hasChildren(grand); else mobileLeafGrand">
                      <div class="mobile-nav-cat mobile-nav-cat--nested" [class.mobile-nav-cat--expanded]="isMobileCategoryExpanded(grand.id)">
                        <button
                          type="button"
                          class="mobile-nav-cat__toggle"
                          (click)="toggleMobileCategory(grand.id, $event)"
                          [attr.aria-expanded]="isMobileCategoryExpanded(grand.id)"
                          [attr.aria-label]="
                            (isMobileCategoryExpanded(grand.id) ? 'header.collapse_category' : 'header.expand_category') | t
                          "
                        >
                          <span class="mobile-nav-cat__chevron" aria-hidden="true"></span>
                        </button>
                        <a class="mobile-nav-cat__name" [routerLink]="['/category', grand.id]" (click)="closeMobileMenu()">
                          {{ grand | categoryName }}
                        </a>
                        <span class="mobile-nav-cat__count" *ngIf="categoryCount(grand) as grandCount">{{ grandCount }}</span>
                      </div>
                      <div class="mobile-nav-cat__children mobile-nav-cat__children--deep" *ngIf="isMobileCategoryExpanded(grand.id)">
                        <a
                          class="mobile-nav-cat__child"
                          *ngFor="let leaf of getChildren(grand); trackBy: trackByCategoryId"
                          [routerLink]="['/category', leaf.id]"
                          (click)="closeMobileMenu()"
                        >
                          <span class="mobile-nav-cat__child-name">{{ leaf | categoryName }}</span>
                          <span class="mobile-nav-cat__count" *ngIf="categoryCount(leaf) as leafCount">{{ leafCount }}</span>
                        </a>
                      </div>
                    </div>
                    <ng-template #mobileLeafGrand>
                      <a
                        class="mobile-nav-cat__child"
                        [routerLink]="['/category', grand.id]"
                        (click)="closeMobileMenu()"
                      >
                        <span class="mobile-nav-cat__child-name">{{ grand | categoryName }}</span>
                        <span class="mobile-nav-cat__count" *ngIf="categoryCount(grand) as grandCount">{{ grandCount }}</span>
                      </a>
                    </ng-template>
                  </ng-container>
                </div>
              </div>

              <ng-template #mobileLeafChild>
                <a
                  class="mobile-nav-cat__child"
                  [routerLink]="['/category', child.id]"
                  (click)="closeMobileMenu()"
                >
                  <span class="mobile-nav-cat__child-name">{{ child | categoryName }}</span>
                  <span class="mobile-nav-cat__count" *ngIf="categoryCount(child) as childCount">{{ childCount }}</span>
                </a>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </nav>

      <p class="mobile-nav-section-label">{{ 'header.quick_links' | t }}</p>

      <div class="mobile-nav-quick">
        <a
          class="mobile-nav-quick__link"
          routerLink="/account"
          [queryParams]="{ tab: 'orders' }"
          (click)="closeMobileMenu()"
        >
          <span class="mobile-nav-quick__chevron" aria-hidden="true"></span>
          <span class="mobile-nav-quick__label">{{ 'header.track_order' | t }}</span>
          <span class="mobile-nav-quick__dot" aria-hidden="true"></span>
        </a>
        <a class="mobile-nav-quick__link" routerLink="/wishlist" (click)="closeMobileMenu()">
          <span class="mobile-nav-quick__chevron" aria-hidden="true"></span>
          <span class="mobile-nav-quick__label">{{ 'header.wishlist' | t }}</span>
          <span class="mobile-nav-quick__dot" aria-hidden="true"></span>
        </a>
        <a class="mobile-nav-quick__link" routerLink="/support" (click)="closeMobileMenu()">
          <span class="mobile-nav-quick__chevron" aria-hidden="true"></span>
          <span class="mobile-nav-quick__label">{{ 'header.contact_us' | t }}</span>
          <span class="mobile-nav-quick__dot" aria-hidden="true"></span>
        </a>
        <a
          class="mobile-nav-quick__link"
          routerLink="/account/login"
          *ngIf="!(isLoggedIn$ | async)"
          (click)="closeMobileMenu()"
        >
          <span class="mobile-nav-quick__chevron" aria-hidden="true"></span>
          <span class="mobile-nav-quick__label">{{ 'header.sign_in' | t }}</span>
          <span class="mobile-nav-quick__dot" aria-hidden="true"></span>
        </a>
        <button
          class="mobile-nav-quick__link mobile-nav-quick__link--btn"
          type="button"
          *ngIf="isLoggedIn$ | async"
          (click)="logout(); closeMobileMenu()"
        >
          <span class="mobile-nav-quick__chevron" aria-hidden="true"></span>
          <span class="mobile-nav-quick__label">{{ 'header.logout' | t }}</span>
          <span class="mobile-nav-quick__dot" aria-hidden="true"></span>
        </button>
      </div>
    </div>

    <div class="mobile-nav-drawer__foot">
      <button
        type="button"
        class="mobile-nav-drawer__lang"
        (click)="toggleLanguage()"
        [attr.aria-label]="'header.language' | t"
      >
        {{ (language$ | async) === 'ar' ? ('header.english' | t) : ('header.arabic' | t) }}
      </button>
      <span class="mobile-nav-drawer__copy">© 2026 Zero Tech Egypt</span>
    </div>
  </aside>

  <nav class="category-nav" [attr.aria-label]="'header.shop_by_category' | t" *ngIf="categoriesSplit$ | async as split">
    <div class="category-nav__inner">
      

      
      <div class="cat-link-wrapper"
           *ngFor="let category of split.topLevel; trackBy: trackByCategoryId"
           [class.cat-link-wrapper--open]="hoveredCategoryId === category.id && subcategoryDropdownOpen"
           (mouseenter)="onCategoryHover(category.id)"
           (mouseleave)="onCategoryLeave()"
           (focusin)="onCategoryFocus(category.id)">
        <a [routerLink]="['/category', category.id]"
           routerLinkActive="active"
           class="cat-link"
           [attr.aria-expanded]="category.children?.length ? (hoveredCategoryId === category.id && subcategoryDropdownOpen) : null"
           [attr.aria-haspopup]="category.children?.length ? 'true' : null">
          {{ category | categoryName }}
          <span class="dropdown-arrow" *ngIf="category.children?.length" aria-hidden="true">▾</span>
        </a>
      </div>
    </div>

    <!-- Subcategory hover panel (full-width strip with backdrop) -->
    <ng-container *ngIf="getHoveredCategory(split) as category">
      <ng-container *ngIf="subcategoryDropdownOpen && category.children?.length">
        <div class="subnav-backdrop" aria-hidden="true"></div>
        <div class="subnav-panel"
             role="menu"
             [attr.aria-label]="(category | categoryName)"
             (mouseenter)="onSubmenuHover()"
             (mouseleave)="onSubmenuLeave()">
          <div class="subnav-panel__inner">
            <header class="subnav-panel__header">
              <div class="subnav-panel__title">
                <span class="subnav-panel__eyebrow">{{ 'header.shop_by_category' | t }}</span>
                <h3 class="subnav-panel__heading">{{ category | categoryName }}</h3>
              </div>
              <a class="subnav-panel__cta"
                 [routerLink]="['/category', category.id]"
                 (click)="closeSubcategoryDropdown()">
                <span>{{ 'header.view_all' | t }} {{ category | categoryName }}</span>
                <span aria-hidden="true">→</span>
              </a>
            </header>

            <div class="subnav-panel__grid">
              <div class="subnav-card" *ngFor="let child of category.children; trackBy: trackByCategoryId">
                <a class="subnav-card__title"
                   [routerLink]="['/category', child.id]"
                   (click)="closeSubcategoryDropdown()">
                  {{ child | categoryName }}
                </a>
                <ul class="subnav-card__list" *ngIf="child.children?.length">
                  <li *ngFor="let grandchild of child.children; trackBy: trackByCategoryId">
                    <a [routerLink]="['/category', grandchild.id]"
                       (click)="closeSubcategoryDropdown()">
                      {{ grandchild | categoryName }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="mega-backdrop" *ngIf="categoriesDropdownOpen" (click)="closeCategoriesDropdown()"></div>
    <section class="mega-menu" *ngIf="categoriesDropdownOpen">
      <div class="mega-menu__inner">
        <aside class="mega-menu__roots">
          <button
            type="button"
            *ngFor="let root of split.tree; trackBy: trackByCategoryId"
            class="mega-root"
            [class.mega-root--active]="getActiveRoot(split)?.id === root.id"
            (click)="setActiveRoot(root.id)">
            {{ root | categoryName }}
          </button>
        </aside>

        <div class="mega-menu__content" *ngIf="getActiveRoot(split) as activeRoot">
          <a class="mega-menu__heading" [routerLink]="['/category', activeRoot.id]" (click)="closeCategoriesDropdown()">
            {{ ('header.shop_all' | t) + ' ' + (activeRoot | categoryName) }}
          </a>

          <div class="mega-leaf-grid">
            <a
              *ngFor="let leaf of getLeafChildren(activeRoot); trackBy: trackByCategoryId"
              [routerLink]="['/category', leaf.id]"
              class="mega-leaf"
              (click)="closeCategoriesDropdown()">
              {{ leaf | categoryName }}
            </a>
          </div>

          <div class="mega-branches" *ngFor="let branch of getBranchChildren(activeRoot); trackBy: trackByCategoryId">
            <a class="mega-branch-title" [routerLink]="['/category', branch.id]" (click)="closeCategoriesDropdown()">{{ branch | categoryName }}</a>
            <div class="mega-branch-chips">
              <a
                *ngFor="let child of getChildren(branch); trackBy: trackByCategoryId"
                [routerLink]="['/category', child.id]"
                class="mega-chip"
                (click)="closeCategoriesDropdown()">
                {{ child | categoryName }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </nav>
</header>